import objectAssign from 'object-assign';
import { findWhere, filter } from 'underscore'

export function feed( state = { 
	posts: [],
	newPosts: [],
	camps: [],
	questions: [],
	allPostsLoaded : false,
	fetching: {
		posts: false,
		newPosts: false,
		oldPosts: false,
		camps: false,
		questions: false,
		bookmarks: false,
	}
}, action ) {

	switch( action.type ) {

		case 'REQUEST_MAIN_FEED':
			return objectAssign({}, state, {
				posts: [],
				fetching: Object.assign({}, state.fetching, {posts: true})
			})

		case 'RECEIVE_MAIN_FEED':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {posts: false}),
				posts: action.posts
			})

		case 'REQUEST_NEW_MAIN_FEED':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {newPosts: true})
			})

		case 'RECEIVE_NEW_MAIN_FEED':
			let update = {
				fetching: Object.assign({}, state.fetching, {newPosts: false})
			}
			if( 'newPosts' in action && !!action.newPosts.length ) update.newPosts = action.newPosts
			return objectAssign({}, state, update)

		case 'REQUEST_OLDER_MAIN_FEED':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {oldPosts: true})
			})

		case 'RECEIVE_OLDER_MAIN_FEED':
			let currentIDs = state.posts.map( (post) => {return post.ID} ),
				postsToAdd = !!currentIDs.length ? filter(action.posts, (post) => { return currentIDs.indexOf(post.ID) === -1 }) : action.posts;
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {oldPosts: false}),
				posts: !!state.posts.length ? state.posts.concat(postsToAdd) : postsToAdd,
				allPostsLoaded: !postsToAdd.length
			})

		case 'RESET_ALL_POSTS_LOADED':
			return objectAssign({}, state, {
				allPostsLoaded: false
			})

		case 'EMPTY_NEW_MAIN_FEED':
			let newPosts = state.newPosts,
				currentPosts = state.posts
			return objectAssign({}, state, {
				newPosts: [],
				posts: newPosts.concat(currentPosts)
			})

		case 'REQUEST_NEW_REPLY':
			var posts = state.posts,
				newReply = {
					title: action.reply,
					parent: action.parent ? action.parent : 0,
					newPost: true,
					user: action.user,
					date: new Date()
				};
			for (var p = 0; p < posts.length; p++) {

				if( posts[p].ID !== action.statementID ) continue;

				if( 'parent' in action && action.parent > 0 ) {
					for (var r = 0; r < posts[p].replies.length; r++) {
						if( posts[p].replies[r].ID !== action.parent ) continue;
						posts[p].replies[r].children = posts[p].replies[r].children.concat([newReply])
						break;
					}
				} else if( 'replies' in posts[p] ) {
					posts[p].replies.push(newReply)
				} else {
					posts[p].replies = [newReply];
				}

				break;

			}
			return Object.assign({}, state, {
				posts: posts
			})

		case 'RECEIVE_NEW_REPLY':

			var posts = state.posts.slice(),
				statementID = 'ID' in action.statement ? action.statement.ID : '';

			for (var p = 0; p < posts.length; p++) {
				if( posts[p].ID !== statementID ) continue;
				posts[p] = action.statement
				break
			}
			
			return Object.assign({}, state, {
				posts: posts
			})

		case 'REQUEST_UPDATED_REPLY': 
			return state;
			break

		case 'RECEIVE_UPDATED_REPLY':

			var posts = state.posts,
				statementID = action.statementID,
				newReply = action.reply;

			for (var p = 0; p < posts.length; p++) {
				if( posts[p].ID !== statementID ) continue;
				for (var i = 0; i < posts[p].replies.length; i++) {
					if( newReply.ID !== posts[p].replies[i].ID ) {
						for (var c = 0; c < posts[p].replies[i].children.length; c++) {
							if( newReply.ID !== posts[p].replies[i].children[c].ID ) continue;
							posts[p].replies[i].children[c] = newReply
						}
						continue;
					}
					let children = posts[p].replies[i].children
					posts[p].replies[i] = newReply
					posts[p].replies[i].children = children
					break;
				}
				break
			}

			return Object.assign({}, state, {
				posts: posts
			})

		case 'RECEIVE_UPDATED_STATEMENT':

			var posts = state.posts,
				statementID = 'ID' in action.statement ? action.statement.ID : '';

			for (var p = 0; p < posts.length; p++) {
				if( posts[p].ID !== statementID ) continue;
				let replies = posts[p].replies
				posts[p] = action.statement
				posts[p].replies = replies
				break
			}

			return Object.assign({}, state, {
				posts: posts
			})

		case 'REQUEST_QUESTIONS_FEED':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {questions: true})
			})

		case 'RECEIVE_QUESTIONS_FEED':
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {questions: false}),
				questions: action.questions
			})

		case 'RECEIVE_NEW_QUESTIONS_FEED':
			var current_posts = state.questions;
			return objectAssign({}, state, {
				fetching: Object.assign({}, state.fetching, {questions: false}),
				questions: action.questions.concat(current_posts)
			})

		default:
			return state;

	}

}



// WEBPACK FOOTER //
// ./src/js/reducers/feed.js